import { $in as __in, createQueryOperator } from "../../_predicates";
const $in = createQueryOperator(__in);
export {
  $in
};
